import React from 'react';
import PropTypes from 'prop-types';
import sampleSize from 'lodash/sampleSize';
import get from 'lodash/get';
import books from './books';
import Slug from '../slug/slug';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';

export default function Recommender(props) {
  if (!props.initialPageLoad && get(books, 'length')) {
    const randomBooks = sampleSize(books, 4);

    return (
      <div className="recommender">
        <Slug slugName="The Recommender" className="column" />
        {randomBooks.map(book => (
          <div className="book" key={book.affiliate_link}>
            <a
              href={book.affiliate_link}
              target="_blank"
              className="book__link"
              onClick={() => {
                trackGAEvent({
                  eventCategory: 'Recommender',
                  eventAction: 'Book',
                  eventLabel: book.title
                });
              }}
            >
              <figure className="book__cover">
                <img
                  src={book.cover}
                  alt={book.title}
                  className="book__image"
                />
              </figure>
              <cite className="book__title">{book.title}</cite>
              <span className="book__price">${book.price}</span>
            </a>
          </div>
        ))}
        <p className="recommender__disclaimer">
          Thanks for supporting Fast Company with these affiliate links
        </p>
      </div>
    );
  }

  return null;
}

Recommender.propTypes = {
  initialPageLoad: PropTypes.bool.isRequired
};
